// "Enum" for UserStatus (you can adjust the values if needed)
const UserStatusReverse = {
  0: 'Active',
  1: 'Inactive',
  2: 'Blocked',
  3: 'Deleted',
  4: 'Pending',
  5: 'Invited',
  6: 'Registered'
};
export const UserStatus = {
  Active: 0,
  Inactive: 1,
  Blocked: 2,
  Deleted: 3,
  Pending: 4,
  Invited: 5,
  Registered: 6
};

  
  export class UserDTO {
    constructor({ id, name = "", email, organizationId, status, remainingHolidays = 0, remainingOvertime = 0, holidaysByYear={}, firstName = "", surname = "", title = "", position = "", expectedWorkTime = null }) {
      this.id = id;
      this.name = name;
      this.email = email;
      this.organizationId = organizationId;
      // Optionally, you could validate or convert the status here.
      this.status = status;
      this.remainingHolidays = remainingHolidays; // Default value
      this.remainingOvertime = remainingOvertime; // Default value
      this.holidaysByYear = holidaysByYear; // Default value
      this.firstName = firstName; // New field
      this.surname = surname; // New field
      this.title = title; // New field
      this.position = position; // New field
      this.expectedWorkTime = expectedWorkTime; // Per-user Soll: default + dated valid-from entries (null = unset)
    }
    static fromApiResponse(apiUser) {
      return {
        id: apiUser.id,
        name: apiUser.name || "",
        email: apiUser.email,
        organizationId: apiUser.organizationId,
        status: UserStatusReverse[apiUser.status] || "Unknown",
        remainingHolidays: apiUser.remainingHolidays || 0,
        remainingOvertime: apiUser.remainingOvertime || 0,
        holidaysByYear: apiUser.holidaysByYear || {},
        firstName: apiUser.firstName || "",
        surname: apiUser.surname || "",
        title: apiUser.title || "",
        position: apiUser.position || "",
        expectedWorkTime: apiUser.expectedWorkTime || null,
      };
    }
  }
 